<p-confirmDialog key="byrole" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="SelectGrid">
	<label>Facility:</label>
	<p-dropdown
		[disabled]="IsLoading() == true"
		[options]="lstFacility"
		[(ngModel)]="Facility"
		optionLabel="FacilityName"
		[filter]="true"
		filterBy="FacilityName"
		[showClear]="false"
		placeholder="Select a Facility"
		(ngModelChange)="onFacilityChange($event)"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="Facility">
				<div class="form-control NoBorder" style="text-align: left">
					{{ Facility.FacilityName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-FacilityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ FacilityItem.FacilityName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Email Type:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="EmailTypeID" [(ngModel)]="EmailTypeID" (ngModelChange)="onEmailTypeIDChange($event)">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstEmailType" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Table-->
<div class="TopMargin">
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

			<!--INSERT CUSTOM BUTTONS HERE-->
			<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
			<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit</button>
			<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		</div>
	</div>

	<!--Table-->
	<div>
		<p-table
			#mydt
			[value]="lstNotifyEmail"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedNotifyEmail"
			dataKey="NotifyEmailID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--Email-->
					<th>
						<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FacilityCount-->
					<th *ngIf="IsDistrict() == true">
						<!-- <p-columnFilter type="text" field="FacilityCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
					</th>

					<!--FacilityDesc-->
					<th *ngIf="IsDistrict() == true">
						<p-columnFilter type="text" field="FacilityDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
					<th *ngIf="IsDistrict() == true" pSortableColumn="FacilityCount"># of Facilities<p-sortIcon field="FacilityCount"></p-sortIcon></th>
					<th *ngIf="IsDistrict() == true" pSortableColumn="FacilityDesc">Facilities<p-sortIcon field="FacilityDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-NotifyEmail>
				<tr [pSelectableRow]="NotifyEmail" (dblclick)="onRowDblClick(NotifyEmail)">
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ NotifyEmail[col.field] }}
					</td>

					<td *ngIf="IsDistrict() == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ NotifyEmail.FacilityCount }}
					</td>

					<td *ngIf="IsDistrict() == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ NotifyEmail.FacilityDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
			{{ errorMessage }}
		</div>
	</div>
</div>
